import {
  BulkThreatExplainPayload,
  mapSelectedNotes,
} from '../../services/threatExplainService';
import { AddThreatsMode, DomainThreats } from '../../helpers/types';

export interface HomeBulkExplainInput {
  mode: AddThreatsMode;
  singleDomainThreats: DomainThreats;
  uniqueDomainThreats: DomainThreats[];
  status: string;
  commentText: string;
  fnInformation: string;
  selectedNoteIds: number[];
  notesCatalog: any[];
  protectedDomains: any[];
}

export function buildHomeBulkExplainPayload(
  input: HomeBulkExplainInput,
): BulkThreatExplainPayload | null {
  const {
    mode,
    singleDomainThreats,
    uniqueDomainThreats,
    status,
    commentText,
    fnInformation,
    selectedNoteIds,
    notesCatalog,
    protectedDomains,
  } = input;

  const companyNameFor = (protectedAssetName: string): string | null =>
    (protectedDomains ?? []).find(
      (item: any) => item?.Domain?.Name === protectedAssetName,
    )?.Company?.Name ?? null;

  let domains: BulkThreatExplainPayload['domains'];
  let protectedAssetName: string | null;
  let companyName: string | null;

  if (mode === 'single') {
    domains = (singleDomainThreats.createThreats ?? []).map(d => ({
      domain: d,
    }));
    protectedAssetName = singleDomainThreats.protectedAssetName || null;
    companyName = protectedAssetName
      ? companyNameFor(protectedAssetName)
      : null;
  } else {
    domains = (uniqueDomainThreats ?? []).flatMap(row =>
      (row.createThreats ?? []).map(d => ({
        domain: d,
        protected_asset_name: row.protectedAssetName || null,
      })),
    );
    const brandNames = [
      ...new Set(
        uniqueDomainThreats.map(row => row.protectedAssetName).filter(Boolean),
      ),
    ];
    // One shared brand collapses to the top level; mixed brands stay per-domain.
    protectedAssetName = brandNames.length === 1 ? brandNames[0] : null;
    companyName = protectedAssetName
      ? companyNameFor(protectedAssetName)
      : null;
  }

  if (domains.length === 0) return null;

  const analystContext = [commentText.trim(), fnInformation.trim()]
    .filter(Boolean)
    .join('\n\n');

  return {
    domains,
    company_name: companyName,
    protected_asset_name: protectedAssetName,
    status: status || null,
    analyst_context: analystContext || null,
    notes: mapSelectedNotes(selectedNoteIds, notesCatalog),
  };
}
